export interface Attachment {
    id: number;
    url: string;
    source: string;
    foot: string;
    type: string;
    small_url: string;
    title: string;
}

export enum AttachmentType {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    AUDIO = 'AUDIO',
    PDF = 'PDF'
}

export interface AttachmentUpload {
    [key: string]: any;
    id?: number;
    title?: string;
    foot?: string;
    source?: string;
    type: AttachmentType;
}